<template>
  <slot v-if="isTouchPointer" />
  <TooltipProvider v-else v-bind="props">
    <slot />
  </TooltipProvider>
</template>

<script setup lang="ts">
import { TooltipProvider, type TooltipProviderProps } from "reka-ui"
import { useMediaQuery } from "@vueuse/core"

const props = defineProps<TooltipProviderProps>()

const isTouchPointer = useMediaQuery("(hover: none) and (pointer: coarse)")
</script>
